import { isVariableInLS } from '@/shared/lib/isVariableInLS';

export const IS_MIXPANEL_DEBUGGER_ENABLED = isVariableInLS('enableMixpanelDebugger');
